import { createAction } from 'typesafe-actions';

export const setAvailableCmds = createAction('SET_AVAILABLE_CMDS')<string[]>();

export const hideNativeHeader = createAction('HIDE_NATIVE_HEADER')<void>();
